/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import moment from 'moment';
import CollapsibleTable from '../bookings/CollapsibleTable';
import { TMeta, TPageNotification, TSeries, TUser, TWorkerItem } from '../../../types';
import {
    withPushFiltersToUrl,
    withPutUrlSearchFiltersToProps,
} from '../common/decorators';
import history from '../../../history';
import DateDropDown from '../common/datedropdown';
import { SelectRole } from '../../common/SelectRole';
import { ApiDropDown, MatchingDropDown } from '../common/dropdowns';
import SearchBar from '../common/SearchBar';
import RefreshButton from '../../common/refreshbutton';
import { matchingModeCodes, matchingModeLabels, SERIES_BOOKING_MODE } from '../../../consts';
import { FRONTEND_SERVER } from '../../../config';
import SeriesTableSubComponent from './SeriesTableSubComponent';
import Tooltip from '../../common/Tooltip';
import BooleanDropdown from '../common/BooleanDropdown';
import { findKeyByValue } from '../../../utils';


type TRow = { original: TSeries; value: string }

type TSeriesTableProps = {
    user: TUser;
    meta: TMeta;
    data: TSeries[];
    pages: number;
    showPaginationBottom: boolean;
    loading: boolean;
    notification: TPageNotification;
    currentPage: number;
    onFilterChange: () => void;
    onPageChange: () => void;
    reloadData: () => void;
    searchValue: string;
    selectedSeries: TSeries,
    selectedFreelancers: TWorkerItem[];
    setSelectedSeries: (item: TSeries) => void;
    setSelectedFreelancers: (item: any[]) => void;
}

type TSeriesTableState = {
    selectedSeries: TSeries | null;
    isModalCancelWorkerOpen: boolean;
    isModalCancelSeriesOpen: boolean;
    isModalEditRatesOpen: boolean;
    isModalSeriesQualifyingQuestionsOpen: boolean;
    isModalSeriesConsultantSplitsOpen: boolean;
    isModalChangeMatchingModeOpen: boolean;
}


// @ts-ignore
@withPushFiltersToUrl
// @ts-ignore
@withPutUrlSearchFiltersToProps
export default class SeriesTable extends Component<TSeriesTableProps, TSeriesTableState> {

    constructor(props: TSeriesTableProps) {
        super(props);
        this.state = {
            ...this.state,
            isModalCancelWorkerOpen: false,
            isModalCancelSeriesOpen: false,
            isModalEditRatesOpen: false,
            isModalSeriesQualifyingQuestionsOpen: false,
            isModalSeriesConsultantSplitsOpen: false,
            isModalChangeMatchingModeOpen: false,
        };
    }

    componentDidMount() {
        this.props.setSelectedFreelancers([]);
        this.props.setSelectedSeries(null);
    }

    canExpandRow(series: TSeries) {
        return series.managed && !series.is_cancelled;
    }

    onBookWorkers = (series: TSeries) => {
        this.props.setSelectedSeries(series);

        const filterPublishedFreelancers = '&worker_status=published&published=1&is_active=1&page=1';

        history.push(`/freelancers?mode=${SERIES_BOOKING_MODE}${filterPublishedFreelancers}`);
    }

    handleOpenModal = (modalName: string) => {
        this.setState(prevState => ({
            ...prevState,
            [`isModal${modalName}Open`]: true,
        }));
    }

    handleCloseModal = (modalName: string) => {
        this.setState(prevState => ({
            ...prevState,
            [`isModal${modalName}Open`]: false,
        }));
    }

    renderDropDownFilters = () => {
        const currentUrlParams = new URLSearchParams(history.location.search);

        return (
            <div className="table-filter-container-outer">
                <div className="table-filter-container hidable">
                    <div className="table-action-bar filters">
                        <div className="grouped-buttons">
                            <DateDropDown
                                history={history}
                                onFilterChange={this.props.onFilterChange}
                                data={this.props.data}
                            />
                            <BooleanDropdown
                                onFilterChange={this.props.onFilterChange}
                                currentUrlParams={currentUrlParams}
                                filterKey="is_cancelled"
                                falseLabel="Live"
                                trueLabel="Cancelled"
                            />
                            <SelectRole
                                onFilterChange={this.props.onFilterChange}
                                currentUrlParams={currentUrlParams}
                            />
                            <MatchingDropDown
                                onFilterChange={this.props.onFilterChange}
                            />
                            <ApiDropDown
                                onFilterChange={this.props.onFilterChange}
                                currentUrlParams={currentUrlParams}
                                url={`agencies/${this.props.user.agency.id}/agents/`}
                                filterKey='consultant'
                                labelKey='full_name'
                                valueKey='id'
                                verboseNamePlural='consultants'
                            />
                            <ApiDropDown
                                onFilterChange={this.props.onFilterChange}
                                currentUrlParams={currentUrlParams}
                                url='cost-centres/'
                                filterKey='cost_centre'
                                labelKey='code'
                                valueKey='id'
                                verboseNamePlural='cost centres'
                            />
                            <SearchBar
                                filterKey="search"
                                onFilterChange={this.props.onFilterChange}
                                currentUrlParams={currentUrlParams}
                                value={this.props.searchValue}
                            />
                        </div>
                    </div>

                    <div className="table-action-bar">
                        <RefreshButton
                            reloadData={this.props.reloadData}
                        />
                    </div>
                </div>
            </div>
        );
    };

    render = () => (
        <div className="shifts table-container">
            {this.renderDropDownFilters()}
            <CollapsibleTable
                className="shifts table-content"
                page={this.props.currentPage}
                pageSize={0}
                data={this.props.data}
                pages={this.props.pages}
                columns={this.columns}
                showPaginationBottom={this.props.showPaginationBottom}
                loading={this.props.loading}
                showPageSizeOptions={false}
                manual={true}
                onPageChange={this.props.onPageChange}
                expandUsingURLPrimaryKey={false}
                bulkModeEnabled={false}
                canExpandRow={this.canExpandRow}
                SubComponent={(row: TRow) => (
                    <SeriesTableSubComponent
                        series={row.original}
                        onBookWorkers={this.onBookWorkers}
                        isModalCancelWorkerOpen={this.state.isModalCancelWorkerOpen}
                        isModalCancelSeriesOpen={this.state.isModalCancelSeriesOpen}
                        isModalEditRatesOpen={this.state.isModalEditRatesOpen}
                        isModalSeriesQualifyingQuestionsOpen={this.state.isModalSeriesQualifyingQuestionsOpen}
                        isModalSeriesConsultantSplitsOpen={this.state.isModalSeriesConsultantSplitsOpen}
                        isModalChangeMatchingModeOpen={this.state.isModalChangeMatchingModeOpen}
                        handleOpenModal={this.handleOpenModal}
                        handleCloseModal={this.handleCloseModal}
                        notification={this.props.notification}
                        reloadData={this.props.reloadData}
                    />
                )}
            />
        </div>
    )

    columns = [
        {
            Header: 'Ref',
            accessor: 'series_reference_number',
            sortable: false,
            headerClassName: 'small-col',
            className: 'small-col',
            Cell: (row: TRow) => {
                let tooltipMessage = '';
                let tooltipClass = '';
                if (!row.original.managed) {
                    tooltipMessage = 'This series is managed by other branch';
                    tooltipClass = 'icon-infomation-circle';

                } else if (!row.original.owned) {
                    tooltipMessage = 'This series is delegated by other branch';
                    tooltipClass = 'icon-infomation-circle';
                } else if (row.original.is_multiservice) {
                    tooltipMessage = 'Multi-sector series';
                    tooltipClass = 'icon-check-double-22';
                }
                return (
                    <a href={`${FRONTEND_SERVER}/jobs/list?series=${row.original.id}&getall=1`}>
                        {row.value}
                        {tooltipMessage &&
                            <Tooltip tooltip={<span>{tooltipMessage}</span>}>
                                <i className={`icon ${tooltipClass} margin-5-px`}/>
                            </Tooltip>
                        }
                    </a>
                );
            }
        },
        {
            Header: 'Client',
            accessor: 'client_name',
            sortable: false,
        },
        {
            Header: 'Start',
            accessor: 'first_job_start',
            sortable: false,
            Cell: (row: TRow) => (
                <span>{moment(row.value).format('DD/MM/YYYY')}</span>
            )
        },
        {
            Header: 'End',
            accessor: 'last_job_start',
            sortable: false,
            Cell: (row: TRow) => (
                <span>{moment(row.value).format('DD/MM/YYYY')}</span>
            )
        },
        {
            Header: 'Title',
            accessor: 'series_title',
            sortable: false,
        },
        {
            Header: 'Filled',
            sortable: false,
            headerClassName: 'small-col',
            className: 'small-col',
            Cell: (row: TRow) => (
                <span>{row.original.num_of_confirmed_jobrequests}/{row.original.total_num_of_jobrequests}</span>
            )
        },
        {
            Header: 'DBS Check',
            accessor: 'dbs_check',
            sortable: false,
            headerClassName: 'small-col',
            className: 'small-col',
            Cell: (row: TRow) => (
                <span>{row.value.replace(/^DBS\s/g, '')}</span>
            )
        },
        {
            Header: 'Matching',
            accessor: 'matching_mode',
            sortable: false,
            headerClassName: 'small-col',
            className: 'small-col',
            Cell: (row: TRow) => (
                // @ts-ignore
                <span>{matchingModeLabels[findKeyByValue(matchingModeCodes, row.value)]}</span>
            )
        }
    ]
}
